import { CORP } from "./gf_CML_funcs";

export const CORPORATE_BONDS = CORP;
export const DEFAULT_REDEMPTION_PRICE = 100;
